// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"96dad9cd","453":"dd16f1d7","455":"5d9f0fe7","977":"f70ef60d"}[chunkId] + ".chunk.js";
};